"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var SZ_000001_1DAY_MINUTE = {
    "code": 0,
    "stock": [{
        "time": 150000,
        "date": 20240920,
        "symbol": "000001.sz",
        "name": "000001.sz",
        "minute": [{
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 268900,
            "amount": 2637909,
            "time": 925
        }, {
            "price": 9.8,
            "open": 9.8,
            "low": 9.8,
            "high": 9.8,
            "vol": 1031800,
            "amount": 9740957,
            "time": 930
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 1151100,
            "amount": 10724909,
            "time": 931
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 393900,
            "amount": 3551769,
            "time": 932
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 263000,
            "amount": 2566648,
            "time": 933
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 607900,
            "amount": 5904165,
            "time": 934
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 572900,
            "amount": 5379383,
            "time": 935
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 279300,
            "amount": 2693319,
            "time": 936
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 657100,
            "amount": 6721164,
            "time": 937
        }, {
            "price": 9.8,
            "open": 9.8,
            "low": 9.8,
            "high": 9.8,
            "vol": 194300,
            "amount": 1897728,
            "time": 938
        }, {
            "price": 9.79,
            "open": 9.79,
            "low": 9.79,
            "high": 9.79,
            "vol": 743700,
            "amount": 6861011,
            "time": 939
        }, {
            "price": 9.79,
            "open": 9.79,
            "low": 9.79,
            "high": 9.79,
            "vol": 177000,
            "amount": 1507943,
            "time": 940
        }, {
            "price": 9.8,
            "open": 9.8,
            "low": 9.8,
            "high": 9.8,
            "vol": 578300,
            "amount": 5644093,
            "time": 941
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 241400,
            "amount": 2382664,
            "time": 942
        }, {
            "price": 9.8,
            "open": 9.8,
            "low": 9.8,
            "high": 9.8,
            "vol": 185100,
            "amount": 1795616,
            "time": 943
        }, {
            "price": 9.79,
            "open": 9.79,
            "low": 9.79,
            "high": 9.79,
            "vol": 128300,
            "amount": 1200473,
            "time": 944
        }, {
            "price": 9.8,
            "open": 9.8,
            "low": 9.8,
            "high": 9.8,
            "vol": 207200,
            "amount": 2046803,
            "time": 945
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 281300,
            "amount": 2563236,
            "time": 946
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 462200,
            "amount": 3666942,
            "time": 947
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 702000,
            "amount": 6857940,
            "time": 948
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 248300,
            "amount": 2391145,
            "time": 949
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 425700,
            "amount": 4215573,
            "time": 950
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 1209300,
            "amount": 11872727,
            "time": 951
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 289100,
            "amount": 2748856,
            "time": 952
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 1056100,
            "amount": 10093994,
            "time": 953
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 61600,
            "amount": 618974,
            "time": 954
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 98300,
            "amount": 960153,
            "time": 955
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 570900,
            "amount": 5370773,
            "time": 956
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 183900,
            "amount": 1794731,
            "time": 957
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 362300,
            "amount": 3524252,
            "time": 958
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 667200,
            "amount": 6191609,
            "time": 959
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 697300,
            "amount": 7047027,
            "time": 1000
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 98800,
            "amount": 935807,
            "time": 1001
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 77600,
            "amount": 666160,
            "time": 1002
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 372000,
            "amount": 3338861,
            "time": 1003
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 606500,
            "amount": 5858561,
            "time": 1004
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 261200,
            "amount": 2485505,
            "time": 1005
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 250600,
            "amount": 2453904,
            "time": 1006
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 236700,
            "amount": 2317025,
            "time": 1007
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 71700,
            "amount": 707265,
            "time": 1008
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 173500,
            "amount": 1704975,
            "time": 1009
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 1468100,
            "amount": 13199861,
            "time": 1010
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 135700,
            "amount": 1130609,
            "time": 1011
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 214900,
            "amount": 2125660,
            "time": 1012
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 98700,
            "amount": 970932,
            "time": 1013
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 896000,
            "amount": 9383107,
            "time": 1014
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 128500,
            "amount": 1256943,
            "time": 1015
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 274100,
            "amount": 2787026,
            "time": 1016
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 216300,
            "amount": 2183478,
            "time": 1017
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 185300,
            "amount": 1766975,
            "time": 1018
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 111200,
            "amount": 1053187,
            "time": 1019
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 658600,
            "amount": 6250782,
            "time": 1020
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 581400,
            "amount": 5292856,
            "time": 1021
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 56100,
            "amount": 551607,
            "time": 1022
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 46300,
            "amount": 455425,
            "time": 1023
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 206800,
            "amount": 2051440,
            "time": 1024
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 2101100,
            "amount": 20559006,
            "time": 1025
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 127000,
            "amount": 1212403,
            "time": 1026
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 155400,
            "amount": 1391867,
            "time": 1027
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 183700,
            "amount": 1701366,
            "time": 1028
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 134200,
            "amount": 1290123,
            "time": 1029
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 225000,
            "amount": 2188804,
            "time": 1030
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 363800,
            "amount": 3685999,
            "time": 1031
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 194500,
            "amount": 1864636,
            "time": 1032
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 400200,
            "amount": 4020743,
            "time": 1033
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 313500,
            "amount": 2459395,
            "time": 1034
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 86700,
            "amount": 875997,
            "time": 1035
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 189500,
            "amount": 1858947,
            "time": 1036
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 76800,
            "amount": 754931,
            "time": 1037
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 94600,
            "amount": 931197,
            "time": 1038
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 397500,
            "amount": 3576639,
            "time": 1039
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 110300,
            "amount": 988989,
            "time": 1040
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 136700,
            "amount": 1318300,
            "time": 1041
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 58400,
            "amount": 569522,
            "time": 1042
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 242000,
            "amount": 2459934,
            "time": 1043
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 141400,
            "amount": 1291790,
            "time": 1044
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 90400,
            "amount": 879249,
            "time": 1045
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 152200,
            "amount": 1334307,
            "time": 1046
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 78500,
            "amount": 769413,
            "time": 1047
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 17300,
            "amount": 172232,
            "time": 1048
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 84300,
            "amount": 834414,
            "time": 1049
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 95200,
            "amount": 1000443,
            "time": 1050
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 474300,
            "amount": 4941648,
            "time": 1051
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 72900,
            "amount": 710667,
            "time": 1052
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 67300,
            "amount": 666422,
            "time": 1053
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 53000,
            "amount": 521946,
            "time": 1054
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 195300,
            "amount": 1860345,
            "time": 1055
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 40700,
            "amount": 387767,
            "time": 1056
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 43200,
            "amount": 425263,
            "time": 1057
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 77800,
            "amount": 752205,
            "time": 1058
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 95100,
            "amount": 916542,
            "time": 1059
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 1131400,
            "amount": 10512745,
            "time": 1100
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 109400,
            "amount": 976242,
            "time": 1101
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 69300,
            "amount": 700544,
            "time": 1102
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 238400,
            "amount": 2281279,
            "time": 1103
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 56700,
            "amount": 565519,
            "time": 1104
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 803100,
            "amount": 7779652,
            "time": 1105
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 137900,
            "amount": 1174319,
            "time": 1106
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 217400,
            "amount": 2133607,
            "time": 1107
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 285000,
            "amount": 2762513,
            "time": 1108
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 50100,
            "amount": 477849,
            "time": 1109
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 20700,
            "amount": 203984,
            "time": 1110
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 72300,
            "amount": 712240,
            "time": 1111
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 273900,
            "amount": 2792522,
            "time": 1112
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 56500,
            "amount": 512793,
            "time": 1113
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 149300,
            "amount": 1459725,
            "time": 1114
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 234900,
            "amount": 2153212,
            "time": 1115
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 28700,
            "amount": 284807,
            "time": 1116
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 52400,
            "amount": 516317,
            "time": 1117
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 33400,
            "amount": 297561,
            "time": 1118
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 37000,
            "amount": 353629,
            "time": 1119
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 49500,
            "amount": 472894,
            "time": 1120
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 187900,
            "amount": 1634358,
            "time": 1121
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 143100,
            "amount": 1518036,
            "time": 1122
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 51500,
            "amount": 665139,
            "time": 1123
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 42200,
            "amount": 407015,
            "time": 1124
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 57200,
            "amount": 537870,
            "time": 1125
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 234900,
            "amount": 2288333,
            "time": 1126
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 48600,
            "amount": 486315,
            "time": 1127
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 85200,
            "amount": 827377,
            "time": 1128
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 64200,
            "amount": 632576,
            "time": 1129
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 0,
            "amount": 0,
            "time": 1130
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 391800,
            "amount": 4569966,
            "time": 1300
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 113700,
            "amount": 1147359,
            "time": 1301
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 47900,
            "amount": 475519,
            "time": 1302
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 774700,
            "amount": 7242844,
            "time": 1303
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 357300,
            "amount": 3545444,
            "time": 1304
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 180900,
            "amount": 1767200,
            "time": 1305
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 755000,
            "amount": 7284137,
            "time": 1306
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 148900,
            "amount": 1425295,
            "time": 1307
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 289000,
            "amount": 2412211,
            "time": 1308
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 47000,
            "amount": 365617,
            "time": 1309
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 186100,
            "amount": 1847329,
            "time": 1310
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 186200,
            "amount": 1741982,
            "time": 1311
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 78500,
            "amount": 770168,
            "time": 1312
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 80100,
            "amount": 772284,
            "time": 1313
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 264500,
            "amount": 2610385,
            "time": 1314
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 275300,
            "amount": 2717306,
            "time": 1315
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 299300,
            "amount": 2894796,
            "time": 1316
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 166900,
            "amount": 1719284,
            "time": 1317
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 152000,
            "amount": 1516120,
            "time": 1318
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 177300,
            "amount": 1758805,
            "time": 1319
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 206300,
            "amount": 2013090,
            "time": 1320
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 73100,
            "amount": 710090,
            "time": 1321
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 43300,
            "amount": 425377,
            "time": 1322
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 142100,
            "amount": 1397581,
            "time": 1323
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 261900,
            "amount": 2561784,
            "time": 1324
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 237900,
            "amount": 2195015,
            "time": 1325
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 112600,
            "amount": 1102798,
            "time": 1326
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 167100,
            "amount": 1628841,
            "time": 1327
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 71300,
            "amount": 697970,
            "time": 1328
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 137000,
            "amount": 1353762,
            "time": 1329
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 56200,
            "amount": 549278,
            "time": 1330
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 29300,
            "amount": 288880,
            "time": 1331
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 204900,
            "amount": 2019047,
            "time": 1332
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 138800,
            "amount": 1385535,
            "time": 1333
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 74300,
            "amount": 806402,
            "time": 1334
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 17900,
            "amount": 176820,
            "time": 1335
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 81600,
            "amount": 801483,
            "time": 1336
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 106200,
            "amount": 1049136,
            "time": 1337
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 47200,
            "amount": 458851,
            "time": 1338
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 32500,
            "amount": 317368,
            "time": 1339
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 88600,
            "amount": 819350,
            "time": 1340
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 208700,
            "amount": 1967993,
            "time": 1341
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 55800,
            "amount": 522626,
            "time": 1342
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 85300,
            "amount": 717949,
            "time": 1343
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 173400,
            "amount": 1351362,
            "time": 1344
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 63400,
            "amount": 621682,
            "time": 1345
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 1068500,
            "amount": 12426361,
            "time": 1346
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 127900,
            "amount": 1238628,
            "time": 1347
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 200800,
            "amount": 1612468,
            "time": 1348
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 149100,
            "amount": 1448328,
            "time": 1349
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 18200,
            "amount": 179619,
            "time": 1350
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 48000,
            "amount": 443643,
            "time": 1351
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 62700,
            "amount": 672313,
            "time": 1352
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 63600,
            "amount": 623093,
            "time": 1353
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 42000,
            "amount": 412200,
            "time": 1354
        }, {
            "price": 9.81,
            "open": 9.81,
            "low": 9.81,
            "high": 9.81,
            "vol": 125400,
            "amount": 1167346,
            "time": 1355
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 188100,
            "amount": 2100003,
            "time": 1356
        }, {
            "price": 9.82,
            "open": 9.82,
            "low": 9.82,
            "high": 9.82,
            "vol": 84400,
            "amount": 846211,
            "time": 1357
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 75600,
            "amount": 670155,
            "time": 1358
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 173400,
            "amount": 1433956,
            "time": 1359
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 223100,
            "amount": 2196353,
            "time": 1400
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 123800,
            "amount": 1230462,
            "time": 1401
        }, {
            "price": 9.83,
            "open": 9.83,
            "low": 9.83,
            "high": 9.83,
            "vol": 163500,
            "amount": 1595113,
            "time": 1402
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 495900,
            "amount": 4742206,
            "time": 1403
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 168700,
            "amount": 1644140,
            "time": 1404
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 209700,
            "amount": 2063327,
            "time": 1405
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 818000,
            "amount": 8842024,
            "time": 1406
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 343100,
            "amount": 3111729,
            "time": 1407
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 723000,
            "amount": 6990466,
            "time": 1408
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 508200,
            "amount": 4969230,
            "time": 1409
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 143400,
            "amount": 1410462,
            "time": 1410
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 233100,
            "amount": 2266432,
            "time": 1411
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 411600,
            "amount": 3904942,
            "time": 1412
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 124300,
            "amount": 1197972,
            "time": 1413
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 695300,
            "amount": 6424912,
            "time": 1414
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 549900,
            "amount": 5409484,
            "time": 1415
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 246000,
            "amount": 2297714,
            "time": 1416
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 203100,
            "amount": 1958750,
            "time": 1417
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 216400,
            "amount": 2121772,
            "time": 1418
        }, {
            "price": 9.84,
            "open": 9.84,
            "low": 9.84,
            "high": 9.84,
            "vol": 795900,
            "amount": 7562199,
            "time": 1419
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 254800,
            "amount": 2428686,
            "time": 1420
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 397000,
            "amount": 3812174,
            "time": 1421
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 631400,
            "amount": 5845843,
            "time": 1422
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 342200,
            "amount": 3355263,
            "time": 1423
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 230800,
            "amount": 2227190,
            "time": 1424
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 312700,
            "amount": 3103682,
            "time": 1425
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 243100,
            "amount": 2344076,
            "time": 1426
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 276900,
            "amount": 2716458,
            "time": 1427
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 280200,
            "amount": 2735661,
            "time": 1428
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 182000,
            "amount": 1823966,
            "time": 1429
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 443700,
            "amount": 4153525,
            "time": 1430
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 135400,
            "amount": 3474575,
            "time": 1431
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 162200,
            "amount": 1583748,
            "time": 1432
        }, {
            "price": 9.86,
            "open": 9.86,
            "low": 9.86,
            "high": 9.86,
            "vol": 366400,
            "amount": 3511742,
            "time": 1433
        }, {
            "price": 9.85,
            "open": 9.85,
            "low": 9.85,
            "high": 9.85,
            "vol": 311900,
            "amount": 3070393,
            "time": 1434
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 442500,
            "amount": 4428698,
            "time": 1435
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 409600,
            "amount": 4073268,
            "time": 1436
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 595000,
            "amount": 5749251,
            "time": 1437
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 598100,
            "amount": 5785084,
            "time": 1438
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 521400,
            "amount": 5087074,
            "time": 1439
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 674000,
            "amount": 6320348,
            "time": 1440
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 596700,
            "amount": 5836798,
            "time": 1441
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 1055200,
            "amount": 9990736,
            "time": 1442
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 719800,
            "amount": 6938689,
            "time": 1443
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 778200,
            "amount": 7228879,
            "time": 1444
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 692000,
            "amount": 6995587,
            "time": 1445
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 187300,
            "amount": 1730223,
            "time": 1446
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 388900,
            "amount": 3753664,
            "time": 1447
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 877000,
            "amount": 8698898,
            "time": 1448
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 704600,
            "amount": 6070368,
            "time": 1449
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 469900,
            "amount": 4501244,
            "time": 1450
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 496200,
            "amount": 4242656,
            "time": 1451
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 571300,
            "amount": 5591133,
            "time": 1452
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 1138600,
            "amount": 11378119,
            "time": 1453
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 1279800,
            "amount": 11685921,
            "time": 1454
        }, {
            "price": 9.88,
            "open": 9.88,
            "low": 9.88,
            "high": 9.88,
            "vol": 930200,
            "amount": 8856387,
            "time": 1455
        }, {
            "price": 9.89,
            "open": 9.89,
            "low": 9.89,
            "high": 9.89,
            "vol": 482200,
            "amount": 4696433,
            "time": 1456
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 0,
            "amount": 0,
            "time": 1457
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 0,
            "amount": 0,
            "time": 1458
        }, {
            "price": 9.87,
            "open": 9.87,
            "low": 9.87,
            "high": 9.87,
            "vol": 0,
            "amount": 0,
            "time": 1459
        }, {
            "price": 9.9,
            "open": 9.9,
            "low": 9.9,
            "high": 9.9,
            "vol": 4027900,
            "amount": 39176410,
            "time": 1500
        }],
        "yclose": 9.81,
        "limitprice": {
            "max": 10.79,
            "min": 8.83
        }
    }]

    /*暴露外部用的方法*/
};exports.SZ_000001_1DAY_MINUTE = SZ_000001_1DAY_MINUTE;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/DayMinute/000001.sz.1day.minute.js
// module id = 320
// module chunks = 0